<template>
  <v-list>
    <template v-if="!$store.getters.loadedUserSpeech">
      <v-skeleton-loader
        v-for="i in 10"
        :key="'skeleton-meta-speech-id-' + i"
        type="list-item-awatar-two-line"
        dark
        class="skeleton-loader"
      >
      </v-skeleton-loader>
    </template>
    <template v-else>
      <speeches-list-item v-for="speech in $store.getters.UserSpeeches" :key="'meta-speech-id-' + speech.id"  :speech="speech"></speeches-list-item>
    </template>
  </v-list>
</template>

<script>
import SpeechesListItem from './SpeechesListItem'
export default {
  name: 'SpeechesList',
  components: {
    SpeechesListItem
  },
  created () {
    this.$store.dispatch({
      type: 'getSpeeches'
    })
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/colors";
  .skeleton-loader{
    background-color: $itmo-blue;
  }
</style>
